import { queryParams, type RouteQueryOptions, type RouteDefinition } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemListForIndexController::__invoke
* @see app/Http/Controllers/Item/GetItemListForIndexController.php
* @route '/api/item'
*/
const GetItemListForIndexController = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForIndexController.url(options),
    method: 'get',
})

GetItemListForIndexController.definition = {
    methods: ["get","head"],
    url: '/api/item',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemListForIndexController::__invoke
* @see app/Http/Controllers/Item/GetItemListForIndexController.php
* @route '/api/item'
*/
GetItemListForIndexController.url = (options?: RouteQueryOptions) => {
    return GetItemListForIndexController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemListForIndexController::__invoke
* @see app/Http/Controllers/Item/GetItemListForIndexController.php
* @route '/api/item'
*/
GetItemListForIndexController.get = (options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemListForIndexController.url(options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemListForIndexController::__invoke
* @see app/Http/Controllers/Item/GetItemListForIndexController.php
* @route '/api/item'
*/
GetItemListForIndexController.head = (options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemListForIndexController.url(options),
    method: 'head',
})

export default GetItemListForIndexController